import classNames from 'classnames';
import { RevealingSubServicesComponent } from '@sapientpro/sapientpro-data-models';
import styles from './SubservicesList.module.scss';
import SubserviceListItem from './SubserviceListItem';

const SubservicesList = ({ data }: { data: RevealingSubServicesComponent }) => (
  <section className={styles.subservicesWrapper}>
    <h2 className={classNames(styles.sectionTitle, 'container')}>{data.title}</h2>
    <ul>
      {data?.subServicesList?.map(item => (
        <SubserviceListItem
          key={item.id}
          item={item}
        />
      ))}
    </ul>
  </section>
);

export default SubservicesList;
